import { cva, css } from "../../../styled-system/css";

export enum SectionBadgeVariants {
  LightGrey = "lightGrey",
  DarkGrey = "darkGrey",
  Partner = "partner",
  VoltGreen = "voltGreen",
}

const textStyles = {
  fontSize: "body.shrimp",
  lineHeight: "body.shrimp",
  letterSpacing: "body.shrimp",
  desktop: {
    fontSize: "body.mouse",
    lineHeight: "body.mouse",
    letterSpacing: "body.mouse",
  },
};

export const styles = {
  root: () =>
    css({
      width: "fit-content",
      paddingY: "baseUnit.mobile1",
      paddingX: "baseUnit.mobile2",
      display: "flex",
      flexDirection: "row",
      gap: "baseUnit.mobile1",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "baseUnit.mobile3",
    }),
  text: () =>
    css({
      color: "midnight",
      ...textStyles,
    }),
  image: () =>
    css({
      width: "auto",
      height: "18px",
      "&[alt]": {
        ...textStyles,
      },
    }),
};

export const sectionBadgeRecipe = cva({
  variants: {
    variant: {
      [SectionBadgeVariants.LightGrey]: {
        backgroundColor: "backgroundGrey",
      },
      [SectionBadgeVariants.DarkGrey]: {
        backgroundColor: "badgeDarkGrey",
      },
      [SectionBadgeVariants.Partner]: {
        border: "0.55px solid black",
        backgroundColor: "white",
        fontWeight: 800,
      },
      [SectionBadgeVariants.VoltGreen]: {
        backgroundColor: "voltGreen",
        fontWeight: 700,
      },
    },
  },
});
